<template>
  <div id="app">
    <Header></Header>
    <router-view v-if="isRouterAlive" :key="reFresh" class="h-min-vh-50"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Public/Header";
import Footer from "./components/Public/Footer";

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      reFresh: 0
    }
  },
  watch: {

  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      })
    }
  },
  mounted() {
    // 页面刷新时滚动条复位0
    window.addEventListener('beforeunload', e => {
      this.$store.dispatch("scrollToTop");
    })
  }
}
</script>

<style lang="scss">
.pt90 {
  padding-top: 90px !important;
}
</style>
